import ListFeaturePage from '@/common/components/list-route/ListFeaturePage.tsx';
import { getColumns } from '@/features/data/projects/columns.tsx';
import {
  ProjectFilterBarMain,
} from '@/features/data/projects/components/ProjectFilterBarMain.tsx';
import ProjectPagination from '@/features/data/projects/components/ProjectPagination.tsx';
import useProjectQueryFromAtom from '@/features/data/projects/hooks/useProjectQueryFromAtom.tsx';
import { createFileRoute } from '@tanstack/react-router';
import { useMemo } from 'react';

export const Route = createFileRoute('/data/projects')({
  component: RouteComponent,
});

function RouteComponent() {
  const projectsQuery = useProjectQueryFromAtom();
  const columns = useMemo(() => getColumns(), []);

  return (
    <ListFeaturePage
      analyticsSurface="projects"
      storageKey="filter-aside:projects"
      query={projectsQuery}
      columns={columns}
      FilterBar={ProjectFilterBarMain}
      Pagination={ProjectPagination}
    />
  );
}
